import React from "react";
import {
  Header,
  Footer,
  EmailSignup,
  LineSplit,
  QuizLPVoteInPerson1,
  AlertSignup,
  AddressCollectionLower,
} from "../components";

import "../components/QuizLandingPage/QuizLandingPage.style.scss";
import config from "../lib/config";
import { Helmet } from "react-helmet-async";
/*Quiz Landing Page - Voting in person, on election day */
import { Trans, useTranslation } from "react-i18next";
function QuizLanding04() {
  let imageUrl = [window.location.protocol, "//", window.location.host, config.seo.default.image].join("");
  let ogUrl = window.location.href;
  const { t } = useTranslation();
  return (
    <div className="ctn-quiz-landing04">
      <Helmet>
        <title>{t("seo_votePerson_title")}</title>
        <meta name="description" content={t("seo_votePerson_page_description")} />
        <meta name="image" content={imageUrl} />
        <meta name="twitter:title" content={t("seo_votePerson_tw_title")} />
        <meta name="twitter:description" content={t("seo_votePerson_tw_description")} />
        <meta name="twitter:image" content={imageUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta itemProp="name" content={t("seo_votePerson_title")} />
        <meta itemProp="description" content={t("seo_votePerson_page_description")} />
        <meta itemProp="image" content={imageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={ogUrl} />
        <meta property="og:title" content={t("seo_votePerson_page_title")} />
        <meta property="og:description" content={t("seo_votePerson_page_description")} />
        <meta property="og:image" content={imageUrl} />
        <script
          async
          type="module"
          src="https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js"
        ></script>{" "}
      </Helmet>
      <div className="home-top-email">
        <AlertSignup />
      </div>
      <Header />
      <div id="page-wrap">
        <zapier-interfaces-chatbot-embed
          is-popup="true"
          chatbot-id="clw6ma3cx001211koyb07xyml"
          height="600px"
          width="400px"
        ></zapier-interfaces-chatbot-embed>
        <LineSplit isGreen="true" />
        <div className="quiz-landing-header">
          <div className="quiz-landing-title">
            <h1>
              {t("your_vote_matters")} <br />
              {/* This November, <span className="bg-emphasis">make it count.</span> */}
              <Trans i18nKey="this_november">
                <span className="bg-emphasis"></span>
              </Trans>
            </h1>
          </div>
        </div>
        <LineSplit isGreen="true" noMarginBottom="true" />
        <QuizLPVoteInPerson1 />
        {/* <AddressCollectionLower /> */}
        <LineSplit isGreen="true" />
        <EmailSignup isMidPage="true" />
        <LineSplit isGreen="true" />
        <Footer flat={true} />
      </div>
    </div>
  );
}

export default QuizLanding04;
